import type { CSMSDK } from '@atlassian/customer-service-management-widget-sdk-types';

type SDKCommands = Parameters<CSMSDK>;

type CommandParams<Command extends SDKCommands[0]> =
	Extract<SDKCommands, [Command, ...any[]]> extends [Command, ...infer Args] ? Args : never;

const createCommand = <Command extends SDKCommands[0]>(command: Command) => {
	const fn = (...args: CommandParams<Command>): void => {
		if (typeof window === 'undefined' || !window.CSM) {
			// eslint-disable-next-line no-console
			console.warn('CSM SDK has not been loaded!');
			return;
		}

		// @ts-ignore i give up
		window.CSM(command, ...args);
	};

	return fn;
};

/**
 * Open the widget
 */
export const open = createCommand('open');

/**
 * Close the widget
 */
export const close = createCommand('close');

/**
 * Hide the widget off the screen
 */
export const hide = createCommand('hide');

/**
 * Show the widget on the screen
 */
export const show = createCommand('show');

/**
 * Update the widget style
 */
export const update = createCommand('update');

/**
 * Create a new conversation
 */
export const createNewConversation = createCommand('createNewConversation');

/**
 * Subscribe to the widget open event
 * @param callback - The callback to call when the widget is opened
 */
export const onOpen = createCommand('onOpen');

/**
 * Subscribe to the widget close event
 * @param callback - The callback to call when the widget is closed
 */
export const onClose = createCommand('onClose');

/**
 * Get the current conversation
 * @param callback - The callback to call when the conversation is retrieved
 */
export const getCurrentConversation = createCommand('getCurrentConversation');
